export default function (date) {
	let ret = false;

	const dateNum = date.getDate();
	const monthNum = date.getMonth() + 1;
	const yearNum = date.getFullYear();
	const monthDay = `${monthNum}/${dateNum}`; // month / day

	const weekdayNum = date.getDay();
	const weekNum = Math.floor((dateNum - 1) / 7) + 1;
	const monthWeekWeekday = `${monthNum}/${weekNum}/${weekdayNum}`; // month / week / weekday

	let dtTemp = new Date(date);
	dtTemp.setDate(1);
	dtTemp.setMonth(dtTemp.getMonth() + 1);
	dtTemp.setDate(dtTemp.getDate() - 1);
	const weekFromEndOfMonthNum =
		Math.floor((dtTemp.getDate() - dateNum - 1) / 7) + 1;
	const monthWeekFromEndWeekday = `${monthNum}/${weekFromEndOfMonthNum}/${weekdayNum}`; // month / week from end of month / weekday

	// month / day
	const newYearsDay = "1/1";
	const goodFriday = getGoodFridayDate(yearNum);
	const independenceDay = "7/4";
	const christmasDay = "12/25";
	const juneteenth = "6/19";

	// month / week / weekday
	const mlkDay = "1/3/1"; // third Monday in January
	const presidentsDay = "2/3/1"; // third Monday in February
	const laborDay = "9/1/1"; // first Monday in September
	const thanksgivingDay = "11/4/4"; // fourth Thursday in November

	// month / week from end of month / weekday
	const memorialDay = "5/1/1"; // last Monday in May

	if (
		monthDay === newYearsDay ||
		monthDay === goodFriday ||
		monthDay === independenceDay ||
		monthDay === christmasDay ||
		monthDay === juneteenth ||
		monthWeekWeekday === mlkDay ||
		monthWeekWeekday === presidentsDay ||
		monthWeekWeekday === laborDay ||
		monthWeekWeekday === thanksgivingDay ||
		monthWeekFromEndWeekday === memorialDay
	) {
		ret = true;
	}

	return ret;
}

function getGoodFridayDate(year) {
	const a = Math.floor(year / 100);
	const b = year - 19 * Math.floor(year / 19);
	const c = Math.floor((a - 17) / 25);
	let d = a - Math.floor(a / 4) - Math.floor((a - c) / 3) + 19 * b + 15;
	d = d - 30 * Math.floor(d / 30);
	d =
		d -
		Math.floor(d / 28) *
			(1 -
				Math.floor(d / 28) *
					Math.floor(29 / (d + 1)) *
					Math.floor((21 - b) / 11));
	let e = year + Math.floor(year / 4) + d + 2 - a + Math.floor(a / 4);
	e = e - 7 * Math.floor(e / 7);
	const f = d - e;
	const month = 3 + Math.floor((f + 40) / 44);
	const day = f + 28 - 31 * Math.floor(month / 4);
	let dtTemp = new Date(Date.UTC(year, month - 1, day, 23, 0, 0));
	dtTemp.setDate(dtTemp.getDate() - 2);
	const goodFridayMonth = dtTemp.getMonth() + 1;
	const goodFridayDate = dtTemp.getDate();

	return `${goodFridayMonth}/${goodFridayDate}`;
}
